import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNetworkStatus } from './InternetCheck';
import image4 from '../../assests/images/Image 4.png';
import image5 from '../../assests/images/Image 5.png';
import styles from './NoInternet.module.css';

const NoInternet = () => {
  const navigate = useNavigate();
  const online = useNetworkStatus();

  useEffect(() => {
    if (online) {
      const path = localStorage.getItem('recentPath') || '/home';
      navigate(path);
    }
  }, [online, navigate]);

  return (
    <div className={styles.main}>
      <div className={styles.leftBg}>
        <img src={image4} alt="background" />
      </div>
      <div className={styles.rightBg}>
        <img src={image5} alt="background" />
      </div>
      <div className={styles.container}>
        <div className={styles.formContainer}>
          <h3 className={styles.welcomeText}>No Internet Connection</h3>
          <p className={styles.message}>Check the network cables, modem, and router, or reconnect your Wi-Fi connection.</p>
          <p className={styles.thanks}>Thanks!</p>
        </div>
      </div>
    </div>
  );
};

export default NoInternet;
